const state = {
    review: {},
    follow: [],
    showLoad: false,
    fundNoticeInfo: {}
}

export default state



// WEBPACK FOOTER //
// ./src/store/store.js